import { FoldableSection } from './FoldableSection';

export default FoldableSection;
